/**
 * Configuration field types used throughout the application
 */
export const AppConfigTypes = {
    STRING: 'string',
    BOOLEAN: 'boolean',
    IMAGE: 'image',
    INTEGER: 'integer',
    INTEGER_OPTIONS: 'integer-options',
    SELECT: 'select'
};
//# sourceMappingURL=appConfig.js.map